import React from "react";

/**
 * Encabezado de las páginas internas (categoría, producto, búsqueda).
 */
const PageIntro = ({ eyebrow, title, aside }) => (
	<div className="mb-8 border-b border-line pb-5 lg:mb-10">
		<div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between sm:gap-8">
			<div className="min-w-0">
				{ eyebrow && <p className="eyebrow">{ eyebrow }</p> }
				<h1 className="mt-2.5 text-[32px] font-semibold leading-none tracking-headline lg:text-[44px]">
					{ title }
				</h1>
			</div>
			{
				aside &&
					<p className="m-0 flex-none text-[10px] font-semibold uppercase tracking-[.065em] text-muted">{ aside }</p>
			}
		</div>
	</div>
);

export default PageIntro;
